
import * as storyblokRuntime$TltcifqG7Gbailr1CrG69rEMrzt6ByKOSQCkM0OgGk0 from '/codebuild/output/src833585057/src/ark/node_modules/@nuxt/image/dist/runtime/providers/storyblok'
import * as awsAmplifyRuntime$YbZz5txlgnPRfJhQzT0InK8gE2AFrfWvj2_45PvuDSUqI from '/codebuild/output/src833585057/src/ark/node_modules/@nuxt/image/dist/runtime/providers/awsAmplify'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "awsAmplify",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['storyblok']: { provider: storyblokRuntime$TltcifqG7Gbailr1CrG69rEMrzt6ByKOSQCkM0OgGk0, defaults: {"baseURL":"https://a.storyblok.com"} },
  ['awsAmplify']: { provider: awsAmplifyRuntime$YbZz5txlgnPRfJhQzT0InK8gE2AFrfWvj2_45PvuDSUqI, defaults: {} }
}
        